import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ChatBubble from '../../../components/ChatBubble/ChatBubble';
import Button from '../../../components/Button/Button';

export default function Finish({ category, resetProgress }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="wrong__container">
      <ChatBubble
        finish
        text={t('staticPages.firstAidChild.completionLead')}
        text2={t(category)}
        text3={t('staticPages.firstAidChild.achievementUnlocked')}
      />
      <div className="finish__buttons">
        <Button hierarchy="primary" width="smallWidth" onClick={() => navigate('/homepage')}>
          {t('staticPages.firstAidChild.backToMapButton')}
        </Button>
        <Button hierarchy="secondary" width="smallWidth" onClick={resetProgress}>
          {t('staticPages.firstAidChild.Restart')}
        </Button>
      </div>
    </div>
  );
}

Finish.propTypes = {
  category: PropTypes.string.isRequired,
  resetProgress: PropTypes.func.isRequired,
};
